export default __webpack_public_path__ + "static/media/WStore_VersePerks.71216c0a.png";